import { useTheme, isDarkTheme } from 'foundations-theming/utils';

export const useIsDarkMode = (): boolean => {
  const theme = useTheme();
  return isDarkTheme(theme);
};
